import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Preloader from "../components/Preloader";
import MagnetCursor from "../components/MagnetCursor";
import ScrollToTop from "../components/ScrollToTop";

const PRIVACY_API = "https://backenddev.aaerlaw.com/api/user/paraclearth_page/privacy";

function PrivacyPolicy() {
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const preloader = document.getElementById("preloader");
    if (preloader) preloader.style.display = "none";

    fetch(PRIVACY_API)
      .then((r) => r.json())
      .then((data) => setPage(data))
      .catch(() => setPage(null))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <Preloader />

      {/* Breadcrumb */}
      <div
        className="breadcrumb-section bg-img jarallax"
        data-jarallax=""
        data-speed="0.6"
        style={{ backgroundImage: "url('assets/img/bg-img/73.jpg')" }}
      >
        <div className="divider"></div>
        <div className="container">
          <div className="breadcrumb-content">
            <h2
              className="wow fadeInUp"
              data-wow-duration="1000ms"
              data-wow-delay="700ms"
            >
              {page?.title || "Privacy & Cookie Policy"}
            </h2>
            <ul
              className="list-unstyled wow fadeInUp"
              data-wow-duration="1000ms"
              data-wow-delay="1000ms"
            >
              <li>
                <Link className="magnet-link" to="/">
                  Home
                </Link>
              </li>
              <li>Privacy &amp; Cookie Policy</li>
            </ul>
          </div>
        </div>
        <div className="divider"></div>
      </div>

      {/* Content */}
      <div className="bg-white">
        <div className="divider"></div>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-10">
              {loading ? (
                <div className="text-center py-5">
                  <div className="spinner-border text-secondary" role="status">
                    <span className="visually-hidden">Loading…</span>
                  </div>
                </div>
              ) : page && page.content ? (
                <div
                  className="ql-editor"
                  style={{ padding: 0 }}
                  dangerouslySetInnerHTML={{ __html: page.content }}
                />
              ) : (
                <p className="text-muted text-center py-5">
                  Privacy &amp; Cookie Policy content will be available soon.
                </p>
              )}
            </div>
          </div>
        </div>
        <div className="divider"></div>
      </div>

      <MagnetCursor />
      <ScrollToTop />
    </div>
  );
}

export default PrivacyPolicy;
